// extracted by mini-css-extract-plugin
export var divider = "_35-0";
export var dividerText = "_35-1";